<item-preview-wrapper 
    class="waf-policy-custom-preview"
    [config]="config"
    [isItem]="isItem"
>
    <item-preview-wrapper_custom-content
        class="waf-policy-custom-preview__custom-content-section"
        *ngIf="config.mode === wafMode.WAF_MODE_EVALUATION"
    >
        <avi-full-modal-preview-message
            id="waf-policy-preview-message"
            [header]="l10nKeys.wafPolicyLabel | vtranslate"
            [statusText]="l10nKeys.evaluationModeStatusText | vtranslate"
            [statusIcon]="'shield'"
        ></avi-full-modal-preview-message>
    </item-preview-wrapper_custom-content>
</item-preview-wrapper>
